module.exports = __webpack_public_path__ + "static/img/元生平台_banner@2x.0afcc26a.png";